import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getSchedule = async (start, end, classId) => {
  const res = await api.get(
    `Academics/class/schedule${classId ? `/${classId}` : ""}`,
    { params: { start, end } }
  );
  return res.data;
};

const getDisciplines = async classId => {
  const res = await api.get(`ClassDiaryV1/class/${classId}/discipline`, {
    params: {
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const getExams = async idTurmaDisc => {
  const res = await api.get(`ClassDiaryV1/grades/exams`, {
    params: {
      idTurmaDisc
    }
  });
  return res.data;
};

const getGrades = async (idTurmaDisc, idStep, idExam) => {
  const res = await api.get(`ClassDiaryV1/grades`, {
    params: {
      idTurmaDisc,
      idStep,
      idExam
    }
  });
  return res.data;
};

const saveGrades = async data => {
  const res = await api.post(`ClassDiaryV1/grades`, data);
  return res.data;
};

const saveGradesJob = async data => {
  const res = await api.post(`ClassDiaryV1/grades/job`, data);
  return res.data;
};

const saveGradesV2 = async data => {
  const res = await api.post(`ClassDiaryV1/grades-v2/job`, data);
  return res.data;
};

const getGradeEvaluations = async () => {
  return [
    {
      name: "Contínua"
    },
    {
      name: "Acumulada"
    },
    {
      name: "Avaliações"
    }
  ];
};

const getGradePeriods = async idTurmaDisc => {
  const res = await api.get("ClassDiaryV1/periods", {
    params: { idTurmaDisc }
  });
  return res.data;
};

const getGradeEvaluation = async (idTurmaDisc, codEtapa, codProva) => {
  const res = await api.get("ClassDiaryV1/evaluation", {
    params: {
      idTurmaDisc,
      codEtapa,
      codProva
    }
  });

  return res.data;
};

const deleteGradeEvaluations = async data => {
  const res = await api.post("ClassDiaryV1/delete-period", data);
  return res.data;
};

const getGradesGridData = async (idTurmaDisc, period) => {
  const res = await api.get("ClassDiaryV1/grades-v2", {
    params: { idTurmaDisc, period }
  });
  return res.data;
};

const saveTest = async data => {
  const res = await api.post("ClassDiaryV1/test", {
    externalData: UserStore.getUserExternalInfo(),
    ...data
  });
  return res.data;
};

const getReports = async (idTurmaDisc, codTurma) => {
  const res = await api.get("ClassDiaryV1/reports", {
    params: {
      idTurmaDisc,
      classId: codTurma,
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const createReport = async data => {
  const { fileName, filters, id, parameters } = data;
  const res = await api.get("ClassDiaryV1/generate-report", {
    params: {
      fileName,
      filters,
      id,
      ...(parameters ? { parameters } : {})
    },
    timeout: 120000
  });
  return `data:application/pdf;base64,${res.data}`;
};

const createReportJob = async data => {
  const {
    fileName,
    filters,
    id,
    parameters,
    name,
    classId,
    paramMode,
    ra,
    paramValues,
    idTurmaDisc
  } = data;
  const res = await api.post("ClassDiaryV1/generate-report/job", {
    fileName,
    filters,
    id,
    name,
    classId,
    ...(parameters ? { parameters } : {}),
    ...(paramMode ? { paramMode } : {}),
    ...(ra != null && ra !== "" ? { ra } : {}),
    ...(paramValues ? { paramValues } : {}),
    ...(idTurmaDisc != null && idTurmaDisc !== "" ? { idTurmaDisc } : {})
  });
  return res.data;
};

export default {
  getSchedule,
  getDisciplines,
  getExams,
  getGrades,
  saveGrades,
  saveGradesJob,
  saveGradesV2,
  getGradePeriods,
  getGradeEvaluation,
  deleteGradeEvaluations,
  getGradeEvaluations,
  getGradesGridData,
  saveTest,
  getReports,
  createReport,
  createReportJob
};
